module.exports = __webpack_public_path__ + "img/book6.ee56d276.png";